<header
  [ngClass]="{ sticky: isDesktop }"
  fxLayout="row wrap"
  fxLayoutAlign="space-between center"
>
  <jsg-environment-sash fxFlex="100"></jsg-environment-sash>
  <div fxLayout="row" fxLayoutAlign="start center">
    <a href="http://www.alberta.ca"
      ><img src="assets/img/alberta.png" class="logo-header" alt="Alberta"
    /></a>
    <div class="left-bar-title" fxHide.lt-md>
      <h3>{{ caption }}</h3>
      <h4>{{ subCaption }}</h4>
    </div>
  </div>
</header>
